module.exports = __webpack_public_path__ + "img/Image_logo_9.35583229.jpg";